export function normalizeStatus(status) {
  return String(status || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
}

export function isPrazoConcluido(prazo) {
  return (
    normalizeStatus(prazo?.status) === 'concluido' ||
    Boolean(prazo?.concluido || prazo?.dataRealizacao || prazo?.concluidoEm)
  )
}

export function isPrazoOpen(prazo) {
  return !isPrazoConcluido(prazo)
}

export function parseStatus(prazo) {
  const normalizedStatus = normalizeStatus(prazo?.status)

  if (isPrazoConcluido(prazo)) return 'concluido'
  if (normalizedStatus === 'pendente_de_analise' || normalizedStatus === 'pendente_analise') return 'pendente_analise'
  if (normalizedStatus === 'preto' || normalizedStatus === 'fatais_judiciais') return 'preto'
  if (normalizedStatus === 'vermelho') return 'vermelho'
  if (normalizedStatus === 'laranja' || normalizedStatus === 'amarelo') return 'laranja'

  return 'verde'
}
